import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import translate from '../../commonComponents/translate';
import { groupEventsByDay } from '../../commonComponents/agenda/helpers/calendarUtilityFunctions';

function UpcomingEvents(props) {
  const { t, events } = props;
  // group events by date
  const datesOfUpcomingEvents = groupEventsByDay(events);
  // get all dates
  const dates = Object.keys(groupEventsByDay(events)).sort(
    (a, b) => new Date(a) - new Date(b),
  );

  return (
    <div className="m-content m-portlet upcoming-events-container">
      <h3 className="upcoming-events-header">
        {t('my.agenda.upcoming.events')}
      </h3>
      {events?.length > 0 ? (
        <div className="upcoming-events-list">
          {dates.map(date => (
            <div className="date-container" key={date}>
              <h4 className="date-title">{moment(date).format('DD MMM')}</h4>
              <ul>
                {datesOfUpcomingEvents[date].map(event => (
                  <li
                    className={`upcoming-event event-${event.status}`}
                    key={event.name + event.createdAt}
                  >
                    {event.title}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ) : (
        <span className="no-data-hint" style={{ fontSize: '12px' }}>
          {t('my.agenda.zero.upcoming')}
        </span>
      )}
    </div>
  );
}

UpcomingEvents.propTypes = {
  t: PropTypes.func.isRequired,
  events: PropTypes.arrayOf(PropTypes.shape({})),
};

UpcomingEvents.defaultProps = {
  events: [],
};

export default translate(UpcomingEvents);
